export class CPBillingCode {
  recordId?: number;
  contractPartnerName?: string;
  billingCode?: string;
  billingCodeShortDescription?: string;
  relatedProject?: number;
  projectName?: string;
  projectClientName?: string;
  status?: string;
  attachmentRequired?: boolean;
  attachmentRequiredMessage?: string;

  get codeWithDescription():string{
    return this.billingCode + ' - ' + this.billingCodeShortDescription;
  }

  constructor(data: any) {
    this.recordId = data[3]?.value;
    this.contractPartnerName = data[7]?.value;
    this.billingCode = data[15]?.value;
    this.billingCodeShortDescription = data[42]?.value;
    this.relatedProject = data[44]?.value;
    this.projectName = data[46]?.value;
    this.projectClientName = data[47]?.value;
    this.status = data[53]?.value;
    // LH-53 (2026-09-05): "Billing Code - Attachment Required". Read by NAME —
    // the backend resolves the env fid (DEV CP Billing Codes 67). PROD 67 is
    // "Billing Code - Primary Aerial", also a checkbox, so a literal here would
    // silently demand an attachment on every aerial code in production.
    this.attachmentRequired = data['attachmentRequired']?.value;
    // LH-53: optional per-code wording, same named-key contract as the flag.
    this.attachmentRequiredMessage = data['attachmentRequiredMessage']?.value;
  }
}
